(function() {
  var SppHandler,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  SppHandler = App.loadClass('grower::handlers/placement/SppHandler');

  exports.BurrusSoybeansLiteHandler = (function(superClass) {
    extend(BurrusSoybeansLiteHandler, superClass);

    function BurrusSoybeansLiteHandler() {
      this.customPlantingPlan = bind(this.customPlantingPlan, this);
      return BurrusSoybeansLiteHandler.__super__.constructor.apply(this, arguments);
    }

    BurrusSoybeansLiteHandler.prototype.init = function() {
      this.customButtons = [
        {
          'html': '<button class="btn btn-blue" id="pdf_button" data-loading-text="Generating report..."> <i class="fa fa-file-o"></i> Placement Summary Report </button>',
          'click': (function(_this) {
            return function() {
              var layers;
              layers = _this.curStep.stepKO.plantingPlans();
              return _this.actionPdf(layers, false, '#long_pdf_button');
            };
          })(this)
        }, {
          'html': '<br /> <button class="btn btn-blue" style="margin-top: 10px;" id="long_pdf_button" data-loading-text="Generating report..."> <i class="fa fa-file-o"></i> Placement Summary Detail Report </button>',
          'click': (function(_this) {
            return function() {
              var layers;
              layers = _this.curStep.stepKO.plantingPlans();
              return _this.actionPdf(layers, true, '#long_pdf_button');
            };
          })(this)
        }
      ];
      return BurrusSoybeansLiteHandler.__super__.init.call(this);
    };

    BurrusSoybeansLiteHandler.prototype.customPlantingPlan = function(field_id, plan, notes_obj) {
      var notesFn, products;
      products = this.taffyObjects.hybrids;
      this._customProductSubscription = function(stage, product_id) {
        var product;
        product = products({
          id: parseInt(product_id)
        }).first();
        stage.treatment = product != null ? product.default_treatment_id : void 0;
        return notesFn();
      };
      return notesFn = function() {
        var event, i, j, len, len1, notes, product, ref, ref1, ref2, stage, url;
        notes = '';
        ref = plan.events;
        for (i = 0, len = ref.length; i < len; i++) {
          event = ref[i];
          ref1 = event.stages;
          for (j = 0, len1 = ref1.length; j < len1; j++) {
            stage = ref1[j];
            product = products({
              id: parseInt((ref2 = stage.product) != null ? ref2.id : void 0)
            }).first();
            if (product == null) {
              continue;
            }
            notes += product.display_name;
            url = product.tech_sheet_url;
            if (url) {
              notes += " (<a href='" + url + "'>" + url + "</a>)";
            }
            notes += '<br>';
            if (product.description) {
              notes += product.description + '<br/>';
            }
          }
        }
        return notes_obj.notes = notes;
      };
    };

    return BurrusSoybeansLiteHandler;

  })(SppHandler);

}).call(this);
